import { api } from '../client'
import type { RequestOptions } from '../client'
import type { CompanyProfileResponse, UpdateCompanyProfileRequest } from './types'

export const companyProfileApi = {
  get: (options?: RequestOptions) =>
    api.get<CompanyProfileResponse>('/settings/company-profile', options),

  update: (body: UpdateCompanyProfileRequest) =>
    api.put<CompanyProfileResponse>('/settings/company-profile', body),
}

export type * from './types'
